import { NotifyMessage } from '../../models/notify-message';
import { ViewManagerService } from '../../services/view-manager-service';
import { ModalNotifyService } from '../../services/modal-notify.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import 'rxjs';
import { Subscription } from 'rxjs';

declare var $: any;
declare var closeModal: any;
declare var openModal: any;
declare var removeFade: any;

@Component({
    selector: 'div [confirm-modal]',
  templateUrl: 'confirm-modal.component.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class ConfirmModal implements OnInit {

  show: boolean = true;
  subscription: Subscription;
  subscriptionPerStampa: Subscription;
  msg: NotifyMessage;
  title: string= "";
  callbackConfirm: boolean;
  redirect: boolean;

  constructor(private modalNotifyService: ModalNotifyService, private viewManagerService: ViewManagerService, private router: Router) {
    this.subscription = this.modalNotifyService.notifyMsg.subscribe(msg => this.openConfirmModal(msg));
  }

  ngOnInit() {
    this.subscriptionPerStampa = this.viewManagerService.ctxHeader.subscribe(res => this.show = res);
    this.viewManagerService.showModal.subscribe(result => {
      if(result) this.show = result;
    });
  }

  openConfirmModal(msg: NotifyMessage) {
    this.msg = msg;
    this.callbackConfirm = msg.callbackConfirm;
    this.redirect = msg.redirect;
    this.title = msg.title;
    if (typeof openModal !== 'undefined') {
      openModal('modaleDiConferma');
    } else {
      $('#modaleDiConferma').modal('show');
    }
  }

  closeConfirmModal() {
    if (typeof closeModal !== 'undefined') {
      closeModal('modaleDiConferma');
    } else {
      $('#modaleDiConferma').modal('hide');
    }
    if (this.redirect) {
      if (this.msg.fascicoloId) {
      this.router.navigate([this.msg.redirectTo, this.msg.fascicoloId]);
      } else {
        this.router.navigate([this.msg.redirectTo]);
      }
    }
  }

  closeAndExit() {
    // closeModal('modaleDiConferma');
    this.closeConfirmModal();
    if (this.callbackConfirm) {
      this.modalNotifyService.notifyConfirm.next(true);
    } else {
      if (this.redirect) {
        this.router.navigate(['']);
      }
    }
  }

  closeAndRedirect(msg: NotifyMessage) {
    // closeModal('modaleDiConferma');
    this.closeConfirmModal();
    if (this.callbackConfirm) {
      this.modalNotifyService.notifyConfirm.next(true);
    } else {
      if (this.redirect) {
        if (msg.fascicoloId) {
        this.router.navigate([msg.redirectTo, msg.fascicoloId]);
        } else {
          this.router.navigate([msg.redirectTo]);
        }
      }
    }
  }

  onCancelClick() {
    if (this.callbackConfirm) {
      this.modalNotifyService.notifyConfirm.next(false);
    }
    this.closeConfirmModal();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.subscriptionPerStampa.unsubscribe();
  }

}
